export enum commonInboxType {
  INSTITUTIONAL = 'institutional',
  CROSS_INSTITUTIONAL = 'cross_institutional',
}
